import { MultiValue, SingleValue } from 'react-select';

import { ComboDropdownValuePill, ComboDropdownValuePillProps } from './ComboDropdownValuePill';
import { PillButtonCombobox, PillButtonComboboxProps } from './PillButtonCombobox';
import { usePopout, FloatingPortal } from '../../ui-kit/hooks/usePopout';

export type DropdownPillComboboxSingleValueProps<T> = Omit<
  PillButtonComboboxProps<T, false>,
  'onCloseBtnClick' | 'onValueSelected' | 'isMulti' | 'value'
> &
  ComboDropdownValuePillProps & {
    value: T | null;
    onValueChanged: (value: T | null) => void;
    valueToString: (value: T | null) => string;
    className?: string;
  };

export function DropdownPillComboboxSingleValue<T extends object>({
  description,
  onValueChanged,
  iconName,
  valueToString,
  value,
  valueElipses,
  iconOnClick,
  className,
  ...comboProps
}: DropdownPillComboboxSingleValueProps<T>) {
  const { refs, getFloatingProps, getReferenceProps, isOpen, floatingStyles, setIsOpen } =
    usePopout();

  function onValueSelected(newValue: SingleValue<T> | MultiValue<T>) {
    onValueChanged(newValue as SingleValue<T>);
  }

  return (
    <>
      <ComboDropdownValuePill
        {...getReferenceProps()}
        ref={refs.setReference}
        value={valueToString(value)}
        valueElipses={valueElipses}
        description={description}
        isActive={isOpen}
        iconName={iconName}
        iconOnClick={iconOnClick}
        className={className}
      />

      {isOpen ? (
        <FloatingPortal>
          <div
            className="z-10"
            ref={refs.setFloating}
            style={floatingStyles}
            {...getFloatingProps()}
          >
            <PillButtonCombobox<T, false>
              {...comboProps}
              value={value || undefined}
              isMulti={false}
              onClose={() => setIsOpen(false)}
              onValueSelected={onValueSelected}
            />
          </div>
        </FloatingPortal>
      ) : null}
    </>
  );
}
